import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

export type UseDashboardReskinExperiment = ModelHookResult<{
	isEnabled: boolean;
}>;

export function useDashboardReskinExperiment(): UseDashboardReskinExperiment {
	const {
		data: {
			viewer: {
				experiments: {
					starterExperienceDashboardReskin: { variation },
				},
			},
		},
	} = useStarterDashboardV2PageData();

	return {
		data: {
			isEnabled: variation === 'enabled',
		},
	};
}
